import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';
import Button from 'elements/Button';
import { useNavigate } from 'react-router-dom';

import { HeaderList, NotificationCount } from './style';

const NotificationHeader: FunctionComponent<any> = ({
  count = 0,
  handleClose,
}) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    handleClose();
    navigate(`/notifications`);
  };

  return (
    <HeaderList>
      <Box display='flex' alignItems='center'>
        <Typography variant='h4' component='span'>
          Unread Notifications
        </Typography>
        <NotificationCount variant='body2' component='span'>
          {count && count < 10 ? `0${count}` : count}
        </NotificationCount>
      </Box>
      <Button onClick={handleNavigate} variant='text' color='secondary'>
        View All
      </Button>
    </HeaderList>
  );
};

export default NotificationHeader;
